import React from 'react';

const PivotSection = ({ dominant }) => {
  const archetypeConfig = {
    performer: {
      title: 'Performer',
      coreBelief: 'My worth is determined by what I achieve'
    },
    ghost: {
      title: 'Ghost',
      coreBelief: 'It\'s safer to stay invisible'
    },
    controller: {
      title: 'Controller',
      coreBelief: 'If I don\'t control it, it will hurt me'
    },
    pleaser: {
      title: 'Pleaser',
      coreBelief: 'My needs don\'t matter as much as theirs'
    },
    destroyer: {
      title: 'Destroyer',
      coreBelief: 'I\'ll burn it down before it controls me'
    }
  };

  const config = archetypeConfig?.[dominant] || archetypeConfig?.performer;

  return (
    <div className="bg-brand-charcoal rounded-lg p-8 md:p-10 border border-brand-slate mb-8 md:mb-10">
      <h2 className="text-2xl md:text-3xl font-bold text-brand-white mb-6 uppercase tracking-tight">
        Why Your Willpower Keeps Failing
      </h2>
      
      <div className="space-y-6 text-base md:text-lg text-brand-steel leading-relaxed">
        <p>
          In the 1960s, British psychoanalyst Dr. Donald Winnicott discovered that children develop a <span className="text-brand-gold font-semibold">"False Self" identity</span> when their environment isn't safe enough for authenticity. It's not a flaw—it's an adaptation.
        </p>
        
        <p>
          When you were young, your environment taught you something—maybe through words, maybe through silence, maybe through what happened when you stepped out of line. The lesson landed: <span className="text-brand-gold font-semibold">{config?.coreBelief}</span>. And a part of you took over to make sure you never forgot it.
        </p>
        
        <p>
          That part is still running. It doesn't know you've grown up. It doesn't know the threats have changed. It's still protecting a child who no longer exists—and treating your adult goals as dangers to be sabotaged.
        </p>
        
        <p>
          This is why you start strong and fade. Why you know what to do but can't make yourself do it. It's not broken motivation. It's an internal civil war.
        </p>
        
        <p className="text-brand-white font-semibold text-lg md:text-xl">
          And you can't win a war you don't know you're fighting.
        </p>
      </div>
    </div>
  );
};

export default PivotSection;